import React from "react";

import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import { Typography } from "@material-ui/core";

import noData from "../assets/images/nodatasmall.png";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      backgroundColor: theme.palette.secondary.light,
      height: "18rem",
      display: "flex",
      alignItems: "center",
      flexDirection: "column",
      justifyContent: "space-between",
      padding: theme.spacing(12, 2, 16, 2),
    },
    img: {
      width: "14rem",
      display: "block",
      [theme.breakpoints.only("xs")]: {
        width: "10rem",
      },
    },
    center: {
      textAlign: "center",
    },
  })
);

type NoDataProps = {
  children?: React.ReactNode;
};

export default function NoData(props: NoDataProps) {
  const classes = useStyles();
  const { children } = props;

  return (
    <div className={classes.root}>
      <img src={noData} alt="no data" className={classes.img} />
      <Typography variant="body1" className={classes.center}>
        {children}
      </Typography>
    </div>
  );
}
